//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
module.exports = {
  PROGRAM_STATUS: "ProgramStatus",
  RT_PERSONA: "RTPersona",
  CascadingClientSpecificData: "CascadingClientSpecificData",
  RT_PROGRAM_CLASS: "RTProgramClass",
  RT_PROGRAM_TEMPLATE: "RTProgramTemplate",
  SERVICE_OFFICE: "ServiceOffice",
  GET_COUNTRY_LIST: "references/data/{locale}/{key}",
  RIGHT_OFFICE_ID: "CMC",
  CANDIDATE_SEARCH: "Candidate",
  SEND_LEAVE_NOTE: "candidates/coachmessage",
  GET_LEAVE_NOTE_MESSAGE: "candidates/coach",
  GET_GENERIC_ACCOUNT: "dashboard/genericUser/{ReferenceCode}",
  GET_ALL_GENERIC_ACCOUNT: "GenericAccount",
  UPDATE_GENERIC_ACCOUNT: "UpdateGenericAccountdetails",
  ADD_GENERIC_ACCOUNT: "create/newuser/genericUser",
  GET_ROLE_PERMISSIONS: "rolespermissions",
  GET_CANDIDATE_ADMIN_DETAILS: "Candidate?ReferenceCode={ReferenceCode}",
  PERSONAL_INFORMATION: "candidates/{id}/profile",
  PROGRAM_DETAIL: "candidates/{referenceId}/programdetail?CandidateId={cid}",
  PLATFORM_DETAIL: "candidates/{referenceId}/programdetail?CandidateId={cid}",
  CONTACT_DETAILS: "candidates/{id}/notificationpreferences",
  COACH_SECTIONS: "candidates/coach",
  UPCOMING_MEETINGS: "CoachingEvents/search",
  JOB_LANDED: "candidates/{id}/journeystatus",
  DELETE_GENERIC_ACCOUNT: "Generic/{ReferenceCode}",
  MASTER_DATA_TIMEZONE: "ReferenceDataService/GetReferenceData",
  GET_MYPROFILE_LABELS: "CMSContent",
  CANDIDATE_LOGIN: "candidates/login?CandidateId={cid}",
  ASSESSMENT_COUNT: "assessments/completedcount?CandidateId={cid}",
  APPLIED_JOBS_COUNT: "jobs/appliedcount?CandidateId={cid}",
  EVENT_COUNT: "events/registeredcount?CandidateId={cid}",
  CANDIDATE_ACTIVYTY: "CandidateActivities",
  CANDIDATE_ACTIVYTY_CREATE_ACTIVITY: "CandidateActivities/ CreateActivity",
  ADMIN_DASHBOARD_JSON: "/AdminLogin/AdminDashboard.json",
  MANAGE_CLIENTS_JSON: "/Clients/ManageClients.json",
  CONTAINER_NAME: "/cirrus-admin",
  CANDIDATE_SEARCH_JSON: "/CandidateSearch/CandidateSearch.json",
  SEARCH_RESULTS_JSON: "/CandidateSearch/CandidateSearchResults.json",
  CANDIDATE_PROFILE_JSON: "/CandidateSearch/CandidateProfile.json",
  CANDIDATE_ACTIVITY_JSON: "/CandidateSearch/CandidateActivity.json",
  CANDIDATE_ACTIVITYSNAPSHOT_JSON:
    "/CandidateSearch/CandidateActivitySnapshot.json",
  ADD_MANAGE_GA_JSON: "/GenericAccounts/ViewGenericAccounts.json",
  CREATE_GA_JSON: "/GenericAccounts/CreateGenericAccounts.json",
  ACC_DETAILS_JSON: "/GenericAccounts/GenericDetailsScreen.json",
  CLIENT_PROFILE_JSON: "/Clients/ClientProfile.json",
  EDIT_EXISTING_CLIENTS_JSON: "/Clients/EditExistingClients.json",
  CREATE_NEW_USER_JSON: "/Users/CreateNewUser.json",
  USER_ACCOUNTS_JSON: "/Users/UserAccounts.json",
  CLIENT_PROFILE: "ClientProfile",
  MANAGE_CLIENTS: "Client",
  COUNTRIES: "country/languagecode",
  LANGUAGES: "references/admin/locales",
  TIMEZONE: "references/data/{lang}/timezone",
  PUBLISH_MESSAGE: "systemmessages",
  USERS: "Users",
  CLIENT_PROGRAM_SETUP_LIST: "Client/ProgramSetup/{ProgramClassId}",
  ADMIN_DASHBOARD_DATA: "/Activities",
  CLIENT_SPECIFIC_CONTENT: "/Clients/ClientSpecificContent.json",
  FOOTER: "/AdminLogin/Footer.json",
  USER_ROLE: "roles",
  USER_LANGUAGE: "Languages/{countryCode}",
  CREATE_NEW_USER: "UserDetail",
  TRACK_ADMIN_ACTIONS: "Activities",
  ADMIN_DASHBOARD_CTA_LINKS: "Platforms",
  SYSTEM_MESSAGE_JSON: "/SystemMessage/SystemMessage.json",
  SYSTEM_MESSAGE: "systemmessages/country/{id}",
  UPDATE_SYSTEM_MESSAGE: "systemmessages/{id}",
  FEATURES_BASED_ON_PROGRAM_CLASS_ID: "FeatureList",
  SAVE_FEATURES_IN_GA: "Client/ProgramSetup/{programSetupId}",
  CLIENT_LIST: "ClientList",
  CREATE_CLIENT_CONTENT: "ClientContent",
  CREATE_CLIENT_CONTENT_SAVE: "ClientContent",
  USER_DETAILS: "UserDetail",
  USER_ACCOUNT: "/UserAccount",
  ERROR_HANDLER: "/AdminLogin/ErrorHandler.json",
  GET_USER_DETAILS_BY_STAFF_ID: "UserDetailsById/{id}",
  GET_CRONOFY_TIMEZONE: "IANATimeZone/{countryCode}/Cronofy",
  GET_CRONOFY_SERVICE_ACCOUNT: "ServiceAccount/Cronofy",
  UPDATE_USER_DETAILS: "UserDetail",
  ADMIN_PAGE_DETAILS: "AdminApi/GetAdminPageDetails",
  TPS_CANDIDATE_BLAKLIST_STATUS: "candidates/{id}/blacklist",
};
